// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"57bd0afe","528":"20a2db74"}[chunkId] + ".chunk.js";
};